module.exports = __webpack_public_path__ + "media/images/mobile-92343e3a.svg";